<template>
  <div class="container mx-auto mb-14 mt-10">
    <div class="relative flex items-center mb-8">
      <div class="absolute inset-y-0 left-46 pr-3 flex items-center">
        <img :src="commonStore.getImgUrl('shared', 'search', 'svg')" style="width: 1vw" />
      </div>
      <input type="text" v-model="factSheetStore.searchTerm" class="mx-auto pl-20 w-10/12 px-4 py-2 rounded-lg border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 input-boxshadow placeholder-bold" :placeholder="t('factSheet.search')" @input="handleFilterItems" />
    </div>

    <div class="grid grid-cols-4 gap-20">
      <div v-for="(item, index) in factSheetStore.filteredItems" :key="'factSheetSelection' + index" class="text-center cursor-pointer" @click="routeTo(item.id)">
        <img :src="commonStore.getImgUrl(item.eggIconObj.componentName, item.eggIconObj.imgName, item.eggIconObj.imgFormat)" style="width: 13.6vw" class="m-auto" />
        <div class="font-jost font-bold text-2xl text-center text-button-light-green mt-5" v-html="t(item.label)" />
      </div>
    </div>
  </div>
</template>


<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { useCommonStore } from "@/stores/common";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { defineComponent } from "vue";

const factSheetStore = useFactSheetStore();
const commonStore = useCommonStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  factSheetStore.filteredItems = factSheetStore.eggDescList;
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};
const handleFilterItems = () => {
  let result = factSheetStore.eggDescList.filter((item) => t(item.label).toLowerCase().includes(factSheetStore.searchTerm.toLowerCase()));
  factSheetStore.filteredItems = result;
};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>

<style scoped>
/*
.container {
  max-width: 800px;
}
*/

input:focus {
  outline: none;
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
}
</style>
<style>
#infoGroup.fact-sheet-subpages a {
  pointer-events: none;
  text-decoration: none; /* Remove underline */
  color: inherit; /* Use the same color as the surrounding text */
}
</style>